import { useCallback, useEffect } from "react";
import { useEntityKey } from "../accessorPropagation/useEntityKey.js";
import { useGetEntityByKey } from "../accessorPropagation/useGetEntityByKey.js";
import { useDesugaredRelativeSingleField } from "../accessorPropagation/useDesugaredRelativeSingleField.js";
const identityFunction = (value) => value;
const useDerivedField = (sourceField, derivedField, transform = identityFunction, agent = "derivedField") => {
  const entityKey = useEntityKey();
  const getEntityByKey = useGetEntityByKey();
  const potentiallyStaleParent = getEntityByKey(entityKey);
  const stableGetEntityReference = potentiallyStaleParent.getAccessor;
  const desugaredSource = useDesugaredRelativeSingleField(sourceField);
  const desugaredDerived = useDesugaredRelativeSingleField(derivedField);
  const potentiallyStaleSourceAccessor = potentiallyStaleParent.getRelativeSingleField(desugaredSource);
  const stableGetSourceReference = potentiallyStaleSourceAccessor.getAccessor;
  const onBeforeUpdate = useCallback(
    (sourceAccessor) => {
      stableGetEntityReference().batchUpdates((getAccessor) => {
        const derivedHostEntity = getAccessor().getRelativeSingleEntity(desugaredDerived);
        if (derivedHostEntity.existsOnServer) {
          return;
        }
        const derivedAccessor = getAccessor().getRelativeSingleField(desugaredDerived);
        if (derivedAccessor.isTouched) {
          return;
        }
        const transformedValue = transform(sourceAccessor.value);
        derivedAccessor.updateValue(transformedValue, {
          agent
        });
      });
    },
    [stableGetEntityReference, desugaredDerived, transform, agent]
  );
  useEffect(
    () => stableGetSourceReference().addEventListener({ type: "beforeUpdate" }, onBeforeUpdate),
    [onBeforeUpdate, stableGetSourceReference]
  );
};
export {
  useDerivedField
};
//# sourceMappingURL=useDerivedField.js.map
